import { NgModule } from '@angular/core';
import {
  HeaderComponent,
  LayoutComponent,
  SidebarComponent,
  TabNavigationComponent,
  ComingSoonComponent,
  RiskScaleComponent,
  PasswordStrengthComponent,
  FirstTimeSetPasswordComponent,
  SalesContactModalComponent,
  TrialExpiredDialogComponent,
  PhaseRenewalBannerComponent,
  ModeSwitcherComponent,
  StackedCardComponent,
  StackedCardFieldComponent,
} from './components';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PrimeNgModule } from './modules';
import { TranslateModule } from '@ngx-translate/core';

const COMPONENTS = [
  LayoutComponent,
  HeaderComponent,
  SidebarComponent,
  ConfirmDialogComponent,
  LoaderComponent,
  TabNavigationComponent,
  ComingSoonComponent,
  RiskScaleComponent,
  PasswordStrengthComponent,
  FirstTimeSetPasswordComponent,
  SalesContactModalComponent,
  TrialExpiredDialogComponent,
  PhaseRenewalBannerComponent,
  ModeSwitcherComponent,
  StackedCardComponent,
  StackedCardFieldComponent,
];
@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, PrimeNgModule, TranslateModule.forChild()],
  exports: [...COMPONENTS],
})
export class SharedModule {}
